import React from 'react';
import classnames from 'classnames';
import { IconProps } from '../icons/types';

export default function EmptyCartIcon({ className, color }: IconProps) {
  return (
    <svg className={classnames('w-4', className)} viewBox="0 0 16 15" fill="none">
      <path
        d="M0.800781 0.703125H1.91336C2.31922 0.703125 2.67486 0.974765 2.78165 1.36632L5.11991 9.93993C5.2267 10.3315 5.58234 10.6031 5.9882 10.6031H12.6981C13.1111 10.6031 13.471 10.3221 13.5712 9.92141L14.9212 4.52141C15.0632 3.95337 14.6336 3.40312 14.0481 3.40312H3.37221M3.8865 13.3031C3.8865 13.5162 3.71381 13.6888 3.50078 13.6888C3.28776 13.6888 3.11507 13.5162 3.11507 13.3031C3.11507 13.0901 3.28776 12.9174 3.50078 12.9174C3.71381 12.9174 3.8865 13.0901 3.8865 13.3031ZM12.8865 13.3031C12.8865 13.5162 12.7138 13.6888 12.5008 13.6888C12.2878 13.6888 12.1151 13.5162 12.1151 13.3031C12.1151 13.0901 12.2878 12.9174 12.5008 12.9174C12.7138 12.9174 12.8865 13.0901 12.8865 13.3031ZM3.49757 13.2999H3.50357V13.3063H3.49757V13.2999ZM12.4976 13.2999H12.5036V13.3063H12.4976V13.2999Z"
        stroke={color ?? 'black'}
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
